export default {
  name: 'pageData',
  namespaced: true,
  state: {
    content: {
      accountType: 'Account Opening',
    },
    countryList: {},
    progressBar: [],
    saveStates: [],
    showPreviousStates: [],
    statesList: [],
    envConfig: {},
    validationRules: {},
    affiliations: {},
    cashPositions: [],
    tStoreResponse: {},
    prospectuses: [],
  },
  mutations: {
    SET_CONTENT: (state, payload) => {
      state.content = payload;
    },
    SET_COUNTRYLIST: (state, payload) => {
      state.countryList = payload;
    },
    SET_PROGRESSBAR: (state, payload) => {
      state.progressBar = payload;
    },
    SET_SAVESTATES: (state, payload) => {
      state.saveStates = payload;
    },
    SET_SHOWPREVIOUSSTATES: (state, payload) => {
      state.showPreviousStates = payload;
    },
    SET_STATESLIST: (state, payload) => {
      state.statesList = payload;
    },
    SET_ENVCONFIG: (state, payload) => {
      state.envConfig = payload;
    },
    SET_VALIDATIONRULES: (state, payload) => {
      state.validationRules = payload;
    },
    SET_AFFILIATIONS: (state, payload) => {
      state.affiliations = payload;
    },
    SET_CASHPOSITIONS: (state, payload) => {
      state.cashPositions = payload;
    },
    SET_TSTORERESPONSE: (state, payload) => {
      state.tStoreResponse = payload;
    },
    SET_PROSPECTUSES: (state, payload) => {
      state.prospectuses = payload;
    },
  },
  actions: {
    set_content: (context, payload) => {
      context.commit('SET_CONTENT', payload);
    },
    set_countryList: (context, payload) => {
      context.commit('SET_COUNTRYLIST', payload);
    },
    set_progressBar: (context, payload) => {
      context.commit('SET_PROGRESSBAR', payload);
    },
    set_saveStates: (context, payload) => {
      context.commit('SET_SAVESTATES', payload);
    },
    set_showPreviousStates: (context, payload) => {
      context.commit('SET_SHOWPREVIOUSSTATES', payload);
    },
    set_statesList: (context, payload) => {
      context.commit('SET_STATESLIST', payload);
    },
    set_envConfig: (context, payload) => {
      context.commit('SET_ENVCONFIG', payload);
    },
    set_validationRules: (context, payload) => {
      context.commit('SET_VALIDATIONRULES', payload);
    },
    set_affiliations: (context, payload) => {
      context.commit('SET_AFFILIATIONS', payload);
    },
    set_cashPositions: (context, payload) => {
      context.commit('SET_CASHPOSITIONS', payload);
    },
    set_tStoreResponse: (context, payload) => {
      context.commit('SET_TSTORERESPONSE', payload);
    },
    set_prospectuses: (context, payload) => {
      context.commit('SET_PROSPECTUSES', payload);
    },
  },
};
